import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    login (email, password) {
      const request = {
        em: email,
        p: password
      }
      return api.post('/login', request)
    },

    updatePreferences (id, preferences) {
      const request = {
        u: id,
        p: preferences
      }

      return api.post('/preferences', request)
    },

    checkSurvey (request) {
      return api.post('/survey/check', request)
    },

    answerSurvey (request) {
      return api.post('/survey/add', request)
    }
  }
} else {
  module = {
    _try: 0,

    login (email, password) {
      this._try++
      const result = (this._try > 1) ? {
        t: 'token',
        n: 'Eiruc',
        f: 'Marie',
        em: 'maire.eiruc@chu-test.fr',
        es: []
      } : { err: 'error' }
      return delay(1000)({ data: result })
    }
  }
}
export default module
